export const numberLayer = [
  { value: 2, text: '2' },
  { value: 4, text: '4' },
  { value: 6, text: '6' },
  { value: 8, text: '8' },
];

export const materialType = [
  { value: 'FR4', text: 'FR4 Tg135' },
  { value: 'FR4TG180', text: 'FR4 Tg180' },
];

export const finishPlating = [
  { value: 'Leaded Solder', text: 'Leaded Solder' },
  { value: 'Lead Free Solder', text: 'Lead Free Solder' },
  { value: 'ENIG', text: 'ENIG' },
  { value: 'Immersion Silver', text: 'Immersion Silver' },
  { value: 'Bare Copper', text: 'Bare Copper' },
  { value: 'OSP', text: 'OSP' },
];

export const cooperInner = [
  { value: '0.5 oz', text: '0.5 oz' },
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
];

export const cooperOuter = [
  { value: '1 oz', text: '1 oz' },
  { value: '2 oz', text: '2 oz' },
  { value: '3 oz', text: '3 oz' },
];

export const MinTrace = [
  { value: '0.012', text: '0.012"' },
  { value: '0.010', text: '0.010"' },
  { value: '0.008', text: '0.008"' },
  { value: '0.007', text: '0.007"' },
  { value: '0.006', text: '0.006"' },
  { value: '0.005', text: '0.005"' },
];

export const solderColor = [
  { value: 'green', text: 'Green' },
  { value: 'Matte Green', text: 'Matte Green' },
  { value: 'Glossy Green', text: 'Glossy Green' },
  { value: 'Black', text: 'Black' },
  { value: 'Glossy Black', text: 'Glossy Black' },
  { value: 'Matte Black', text: 'Matte Black' },
  { value: 'Blue', text: 'Blue' },
  { value: 'Clear', text: 'Clear' },
  { value: 'Red', text: 'Red' },
  { value: 'White', text: 'White' },
];

export const silkscreenColor = [
  { value: 'White', text: 'White' },
  { value: 'Black', text: 'Black' },
  { value: 'Yellow', text: 'Yellow' },
];

export const smallestHoleSizeRange = [
  { value: '12+', text: '12+ mils' },
  { value: '10 - 11.9', text: '10 - 11.9 mils' },
  { value: '8 - 9.9', text: '8 - 9.9 mils' },
];
